import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// `provideClientHydration()` used to live here and that was the bug: this file
// is the BROWSER entry only, so the server never got it and never emitted the
// `ngh` annotations hydration needs. It now sits in `appConfig`, which both
// bootstraps share. Leave `provideZoneChangeDetection()` here — it is
// browser-correct and zone.js is loaded via `polyfills`.
bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
